import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const LayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: '100%',
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const LayoutLogin = (props) => {
  const { children } = props;
  //const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <>
      <LayoutRoot>{children}</LayoutRoot>
    </>
  );
};

LayoutLogin.propTypes = {
  children: PropTypes.node,
};
